export const hotelRegion: any = {
  hotelCountryList: "List of destination countries for hotels",
  hotelRegionList: "Hotel area in {{country}}",
};
